import { Box, Stack, Text } from "@chakra-ui/react";
import { DatePicker, DatePickerProps } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";

type KYDDateTimePickerProps = {
  timezone?: string;
  name: string;
  required?: boolean;
  isDisabled?: boolean;
  dateTimeProps?: DatePickerProps<Dayjs>;
  transform?: {
    input: (val: any) => any;
    output: (val: any) => any;
  };
  info?: string;
  value: string;
  onChange: (date: Dayjs) => void;
  error?: string;
};

const KYDDateTimePicker = ({
  timezone,
  value,
  required = false,
  isDisabled = false,
  dateTimeProps = {},
  onChange,
  error,
  info = "",
}: KYDDateTimePickerProps) => {
  const isInfo = !!info;
  const isError = !!error;
  const color = isError ? "red.400" : isInfo ? "#A1700D" : "transparent";

  return (
    <Stack w="full" spacing={0}>
      <DatePicker
        value={value ? dayjs(value) : null}
        slotProps={{
          textField: {
            error: isError,
            sx: {
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: isInfo ? `${color} !important` : "#E6E6E6",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: isInfo ? `${color} !important` : "#E6E6E6",
              },
              "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                borderColor: "#E6E6E6 !important",
              },
              "&.Mui-disabled:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#E6E6E6 !important",
              },
              "&.Mui-disabled .MuiOutlinedInput-notchedOutline.MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#E6E6E6 !important",
                },
              "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#E6E6E6 !important",
                },
              boxShadow: "0px 0px 10px 0px #0000000D",
              "& .MuiInputBase-input": {
                fontSize: "14px",
                fontFamily: "Work Sans",
                padding: "12px 12px",
                color: "#222",
              },
            },
          },
          actionBar: {
            actions: required ? ["accept"] : ["clear", "accept"],
          },
        }}
        timezone={timezone}
        closeOnSelect
        disabled={isDisabled}
        onChange={(date) => {
          onChange(date);
        }}
        onAccept={(date) => {
          onChange(date);
        }}
        {...dateTimeProps}
      />
      {isInfo && (
        <Box
          h={4}
          borderLeftWidth="2px"
          borderLeftColor={color}
          pl={2}
          mt={1}
          flex={1}
          display="flex"
          alignItems="center"
        >
          <Text fontSize={"sm"} color={color}>
            {info}
          </Text>
        </Box>
      )}
      {isError && (
        <Box
          h={4}
          borderLeftWidth="2px"
          borderLeftColor={color}
          pl={2}
          mt={1}
          flex={1}
          display="flex"
          alignItems="center"
        >
          <Text fontSize={"sm"} color={color}>
            {error}
          </Text>
        </Box>
      )}
    </Stack>
  );
};

export default KYDDateTimePicker;
